/* global femcare, Swiper */

/**
 * A module to initialize and manage all range sliders on the page.
 */
femcare.shared.rangeSlider = {
    sliders: [],

    init() {
        this.initSlider();
    },

    /**
     * Initializes a Swiper instance for each range slider on the page.
     */
    initSlider() {
        const sliders = document.querySelectorAll('.range-slider');

        if (sliders.length) {
            sliders.forEach(slider => {
                const swiperElement = slider.querySelector('.swiper');
                const nextButton = slider.querySelector('.range-slider__next');
                const prevButton = slider.querySelector('.range-slider__previous');
                const scrollbar = slider.querySelector('.swiper-scrollbar');

                const swiperInstance = new Swiper(swiperElement, {
                    slidesPerView: 'auto',
                    navigation: {
                        nextEl: nextButton,
                        prevEl: prevButton,
                    },
                    mousewheel: {
                        forceToAxis: true,
                    },
                    scrollbar: {
                        el: scrollbar,
                    },
                    observer: true,
                    observeParents: true,
                });

                this.sliders.push(swiperInstance);
            });
        }
    },
};
